export { default as UiQuote } from "./UiQuote";
